module.exports = __webpack_public_path__ + "static/media/cuestionario-gestion.969c0256.svg";